import api from 'api';
import { CancelToken } from 'axios';
import node_api from 'node-api';
import { getImpersonationParams } from 'utils/helpers';

import { ReviewList1SummaryResponse, ReviewList2SummaryResponse } from './reviewlist.types';

export class ReviewListLegacyClient {
  async getReviewList1Summary(cancelToken?: CancelToken) {
    const { data }: { data: ReviewList1SummaryResponse } = await api().get('reviews/AUTH_TOKEN', {
      cancelToken,
      // Forward the impersonator so core scopes the RL1 summary counts to the
      // impersonator's clinics during an impersonated session (mirrors the
      // review-list SHOW call). No-op when not impersonating.
      params: { ...getImpersonationParams() },
    });
    return data;
  }

  async getReviewList2Summary(cancelToken?: CancelToken) {
    // reviewlist3-sam — hits the intervened /node-be/v2/reviews endpoint via
    // REACT_APP_API_NODE_BASE_URL. node_api() sends the Authorization header;
    // the legacy /AUTH_TOKEN URL suffix is no longer appended.
    const { data }: { data: ReviewList2SummaryResponse } = await node_api().get('reviews', {
      cancelToken,
    });
    return data;
  }
}
